/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Created_Step_3Inputs */



/**
* | output |
* | --- |
* | "They get only the event groups you picked." |
*
* @param {Team_Share_Created_Step_3Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_created_step_3 = /** @type {((inputs?: Team_Share_Created_Step_3Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Created_Step_3Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("They get only the event groups you picked.")
	if (locale === "de") return /** @type {LocalizedString} */ ("They get only the event groups you picked.")
	if (locale === "it") return /** @type {LocalizedString} */ ("They get only the event groups you picked.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("They get only the event groups you picked.")
	if (locale === "es") return /** @type {LocalizedString} */ ("They get only the event groups you picked.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("They get only the event groups you picked.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("They get only the event groups you picked.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("They get only the event groups you picked.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("They get only the event groups you picked.")
	return /** @type {LocalizedString} */ ("They get only the event groups you picked.")
});